import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';
import { Tag } from '../../features/tags/tagsSlice';

const tagsService = {
  fetchTagsByType: async (tagType: number): Promise<Tag[]> => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params: { tagType },
    };

    const response = await axios.get<Tag[]>(
      `/accommodation/tags/getTags`,
      config,
    );
    return response.data;
  },
  fetchAccommodationTags: async (
    onlyWithActiveAccommodations?: boolean,
  ): Promise<Tag[]> => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params: onlyWithActiveAccommodations
        ? { onlyWithActiveAccommodations: true }
        : undefined,
    };

    const response = await axios.get<Tag[]>(
      `/accommodation/tags/getTags`,
      config,
    );
    return response.data;
  },
  fetchTagDetails: async (tagId: string): Promise<Tag> => {
    const params = { tagId };
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
      params,
    };

    const response = await axios.get<Tag>(
      `/accommodation/tags/getTagDetails`,
      config,
    );
    return response.data;
  },
  saveOrUpdateTag: async (tagData: Tag) => {
    const config = {
      headers: {
        ...apiRequestHeaders.csrfHeader(),
        ...apiRequestHeaders.activeSiteHeader(),
      },
    };

    const response = await axios.post(
      '/accommodation/tags/saveOrUpdate',
      tagData,
      config,
    );
    return response.data;
  },
};

export default tagsService;
